import { useMemo } from "react";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Button from "@mui/material/Button";
import { useListContext } from "react-admin";

const ResetFilterButton = ({ defaultFilters = {}, label = "Reset" }) => {
  const { setFilters } = useListContext();

  const normalizedDefaults = useMemo(() => defaultFilters, [defaultFilters]);

  const handleReset = () => {
    setFilters(normalizedDefaults, {}, false);
  };

  return (
    <Button
      onClick={handleReset}
      size="small"
      startIcon={<RestartAltIcon />}
      sx={{
        width: "fit-content",
        lineHeight: "1.5",
        minWidth: "100px",
        border: "0.1rem solid",
      }}
    >
      {label}
    </Button>
  );
};

export default ResetFilterButton;
